<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first" disabled="disabled">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cpuid" @keyup.enter.native="clicksearch" placeholder="请输入芯片ID" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="注册时间(开始)" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="注册时间(结束)" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Loginname" label="账号" min-width="4%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="4%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="4%"></el-table-column>
          <el-table-column prop="Cpuid" label="芯片ID" min-width="4%"></el-table-column>
          <el-table-column label="初始裸眼视力" align="center">
            <el-table-column prop="Nakedrighteyedegreef" label="OD" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedlefteyedegreef" label="OS" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedbinoculusdegreef" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column label="最新裸眼视力" align="center">
            <el-table-column prop="Nakedrighteyedegreel" label="OD" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedlefteyedegreel" label="OS" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedbinoculusdegreel" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column prop="Createtime" label="注册时间" min-width="7%"></el-table-column>
          <el-table-column label="操作" min-width="7%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goViewVisionReview(scope.row)">视光复查</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="视力复查" name="seven" disabled="disabled">
        <SubRuiYunRslEvManagementUserVisionReview ref="SubVueseven" v-on:triggerFunc="BackToFirst"></SubRuiYunRslEvManagementUserVisionReview>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import SubRuiYunRslEvManagementUserVisionReview from '@/componentsSubVue/SubRuiYunRslEvManagementUserVisionReview.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    SubRuiYunRslEvManagementUserVisionReview
  },
  name: 'MySubRuiYunRslEvManagementUser',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        loginname: '',
        name: '',
        cpuid: '',
        begintime: '',
        endtime: ''
      }
    }
  },
  mounted () {
    this.apiRuiYunGetRslEvUserNum()
    this.apiRuiYunGetRslEvUserList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiRuiYunGetRslEvUserList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiRuiYunGetRslEvUserNum()
      this.apiRuiYunGetRslEvUserList()
    },
    // 查看视力复查
    goViewVisionReview (row) {
      this.activeName = 'seven'
      this.$refs.SubVueseven.LoadData({ name: '', params: { userid: row.Id } })
    },
    apiRuiYunGetRslEvUserList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        cpuid: that.keywords.cpuid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiYunGetRslEvUserList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiRuiYunGetRslEvUserNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        cpuid: that.keywords.cpuid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiYunGetRslEvUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
